import {
    LIST_AUDIENCE_MOTIVES,
    LIST_AUDIENCE_MOTIVES_SUCCESS,
    LIST_AUDIENCE_MOTIVES_ERROR,
    ADD_AUDIENCE_MOTIVES,
    SAVE_AUDIENCE_MOTIVES,
    SAVE_AUDIENCE_MOTIVES_SUCCESS,
    SAVE_AUDIENCE_MOTIVES_ERROR,
    DELETE_AUDIENCE_MOTIVES,
    DELETE_AUDIENCE_MOTIVES_SUCCESS,
    DELETE_AUDIENCE_MOTIVES_ERROR,
    EDIT_AUDIENCE_MOTIVES,
    UPDATE_AUDIENCE_MOTIVES,
    UPDATE_AUDIENCE_MOTIVES_SUCCESS,
    UPDATE_AUDIENCE_MOTIVES_ERROR
} from '../types';

import clienteAxios                                                                     from '../config/axios';
import authToken                                                                        from '../config/token';
import Swal                                                                             from 'sweetalert2';

import audienceMotivesData                                                              from '../data/audienceMotives';
import { SuccessMessage, WaitingMessage, ErrorMessage }                                 from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS, MSG_UPDATE_SUCCESS }     from '../constants/messages';
import { METHOD_DISABLED }                                                              from '../constants/requestMethods';



const controller = 'motivo';

//LISTAR AUDIENCE MOTIVES
export function listAudienceMotivesAction(params) {    
    return async (dispatch) => {
        //Inicializo
        dispatch( listAudienceMotives() );
        //Ejecuto la consulta
        try {
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, {params});
            //Obtengo los datos
            const audienceMotives = response.data;
            //const audienceMotives = audienceMotivesData;
            //Llamo al dispatch
            dispatch( listAudienceMotivesSuccess(audienceMotives.content) );
        }
        catch(error) {
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listAudienceMotivesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listAudienceMotives = () => ({
    type: LIST_AUDIENCE_MOTIVES,
    payload: true
});

const listAudienceMotivesSuccess = audienceMotives => ({
    type: LIST_AUDIENCE_MOTIVES_SUCCESS,
    payload: audienceMotives
});

const listAudienceMotivesError = error => ({
    type: LIST_AUDIENCE_MOTIVES_ERROR,
    payload: error
});



//ADD AUDIENCE MOTIVE
export function addAudienceMotivesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addAudienceMotives(false) );
        //Abro el formulario
        showForm();
    }
}

const addAudienceMotives = isEdit => ({
    type: ADD_AUDIENCE_MOTIVES,
    payload: isEdit
});

//SAVE AUDIENCE MOTIVE
export function saveAudienceMotivesAction(audienceMotive, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveAudienceMotives() );
        //Ejecuto la consulta
        try {
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, audienceMotive);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveAudienceMotivesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        } catch(error) {
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveAudienceMotivesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveAudienceMotives = () => ({
    type: SAVE_AUDIENCE_MOTIVES,
    payload: true
});


const saveAudienceMotivesSuccess = audienceMotive => ({
    type: SAVE_AUDIENCE_MOTIVES_SUCCESS,
    payload: audienceMotive
});

const saveAudienceMotivesError = error => ({
    type: SAVE_AUDIENCE_MOTIVES_ERROR,
    payload: error
});



//EDIT AUDIENCE MOTIVE
export function editAudienceMotivesAction(audienceMotive, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editAudienceMotives(audienceMotive) );
        //Abro el formulario
        showForm();
    }
}

const editAudienceMotives = audienceMotive => ({
    type: EDIT_AUDIENCE_MOTIVES,
    payload: audienceMotive
});

//UPDATE AUDIENCE MOTIVE
export function updateAudienceMotivesAction(audienceMotive, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateAudienceMotives() );
        //Ejecuto la consulta
        try {
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${audienceMotive.id}`, audienceMotive);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateAudienceMotivesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error) {
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateAudienceMotivesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateAudienceMotives = () => ({
    type: UPDATE_AUDIENCE_MOTIVES,
    payload: true
});

const updateAudienceMotivesSuccess = audienceMotive => ({
    type: UPDATE_AUDIENCE_MOTIVES_SUCCESS,
    payload: audienceMotive
});

const updateAudienceMotivesError = error => ({
    type: UPDATE_AUDIENCE_MOTIVES_ERROR,
    payload: error
});



//DELETE AUDIENCE MOTIVE
export function deleteAudienceMotivesAction(audienceMotive) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteAudienceMotives() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try {
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${audienceMotive.id}`);
            const response = await clienteAxios.put(`/${controller}/${audienceMotive.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteAudienceMotivesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }
        catch(error) {
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteAudienceMotivesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteAudienceMotives = () => ({
    type: DELETE_AUDIENCE_MOTIVES,
    payload: true
});

const deleteAudienceMotivesSuccess = audienceMotive => ({
    type: DELETE_AUDIENCE_MOTIVES_SUCCESS,
    payload: audienceMotive
});

const deleteAudienceMotivesError = error => ({
    type: DELETE_AUDIENCE_MOTIVES_ERROR,
    payload: error
});